import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import RepcoSettingsHtml from './repco.settings.html';

export function RepcoStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'RepcoSettingsCtrl',
    name       : 'app.repco-settings',
    templateUrl: RepcoSettingsHtml,
    url        : '/repco_settings',
    resolve    : {
      quote   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company/quote_for_repco'),
      session : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company')
    }
  });
};
